/* eslint-disable camelcase */
function OverviewStatusPills({ aktiviteter, lunsj, middag, aktivitetPameldApent }) {
    const harAktiviteterDenneDagen = aktiviteter.length > 0;
    const harAktivitetValgt = aktiviteter.some(a => a.pameldt === 'J');

    let aktivitetLabel = null;
    let aktivitetClass = '';

    if (harAktiviteterDenneDagen) {
        aktivitetLabel =
            aktivitetPameldApent === 'N'
                ? harAktivitetValgt
                    ? 'Aktivitet registrert'
                    : 'Avventer fordeling'
                : harAktivitetValgt
                  ? 'Aktivitet valgt'
                  : 'Ingen aktivitet valgt';

        aktivitetClass =
            aktivitetPameldApent === 'N'
                ? harAktivitetValgt
                    ? 'is-success'
                    : 'is-muted'
                : harAktivitetValgt
                  ? 'is-success'
                  : 'is-warning';
    }

    return (
        <div className="overview-day-status">
            {aktivitetLabel && (
                <span className={`overview-day-status__pill ${aktivitetClass}`}>
                    {aktivitetLabel}
                </span>
            )}

            {lunsj && (
                <span
                    className={`overview-day-status__pill ${
                        lunsj.pameldt === 'J' ? 'is-success' : 'is-warning'
                    }`}
                >
                    {lunsj.pameldt === 'J' ? 'Lunsj bestilt' : 'Lunsj ikke bestilt'}
                </span>
            )}

            {middag && (
                <span
                    className={`overview-day-status__pill ${
                        middag.pameldt === 'J' ? 'is-success' : 'is-warning'
                    }`}
                >
                    {middag.pameldt === 'J' ? 'Middag bestilt' : 'Middag ikke bestilt'}
                </span>
            )}
        </div>
    );
}

export default OverviewStatusPills;
